<template>
  <div class="my-class">
    <div style="color: #8F8F8F;">当前位置：<span @click="goBack" style="cursor: pointer;">班级管理</span> > {{ className }}</div>
    <div style="display: grid; grid-template-columns: repeat(3, 1fr); grid-gap: 24px; margin: 20px 0;">
      <div style="position: relative;" @click="toPracticalList">
        <img src="../../assets/images/my-class-bg1.png" style="width: 100%; cursor: pointer;" />
        <div style="color: #6D1CFF; position: absolute; top: 50%; right: 24%;"><span style="font-size: 32px;">{{ operNum.sx_num }}</span>次</div>
      </div>
      <div style="position: relative;" @click="toQuizList">
        <img src="../../assets/images/my-class-bg2.png" style="width: 100%; cursor: pointer;" />
        <div style="color: #FFA62F; position: absolute; top: 50%; right: 24%;"><span style="font-size: 32px;">{{ operNum.xc_num }}</span>次</div>
      </div>
      <div style="position: relative;" @click="toDiscussList">
        <img src="../../assets/images/my-class-bg3.png" style="width: 100%; cursor: pointer;" />
        <div style="color: #006EFF; position: absolute; top: 50%; right: 24%;"><span style="font-size: 32px;">{{ operNum.tl_num }}</span>次</div>
      </div>
    </div>
    <div style="flex:1; display: flex;">
        <div class="content-box">
            <el-scrollbar style="height: calc(100vh - 440px); overflow-x: hidden;">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="课程内容" name="课程内容">
                        <div class="course-item" v-for="(item, index) in myCourses">
                            <img :src="item.course_cover" style="width: 167px; height: 100%; border-radius: 8px; margin-right: 20px;">
                            <div style="display: flex; flex-direction: column; justify-content: space-between;">
                                <div style="margin-bottom: 18px;">{{ item.course_name }}</div>
                                <el-progress :percentage="item.progress_rate" style="width: 600px;" :show-text="false" :stroke-width="8"></el-progress>
                                <div>学习章节进度<span style="margin-left: 10px;">{{ item.finish_chapter_num }}/ {{ item.chapter_num }}章</span></div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="历史记录" name="历史记录">
                        <el-table :data="signInData" style="width: 100%; flex: 1; margin-top: 30px; height: calc(100vh - 515px); overflow-y: auto;" stripe :header-cell-style="headStyle" :cell-style="cellStyle">
                        <el-table-column prop="tran_start_time" label="日期"></el-table-column>
                        <el-table-column label="课程">
                            <template slot-scope="scope">
                                <div style="color: #006EFF; cursor: pointer;" @click="targetCourse(scope.row)">{{scope.row.course_name}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="章节">
                            <template slot-scope="scope">
                                <span>{{scope.row.chapter_sign + 1}} / {{scope.row.chapter_num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="t_name" label="授课老师"></el-table-column>
                    </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-scrollbar>
        </div>
        <div class="student-box">
            <el-scrollbar>
                <div style="padding: 0 20px 20px 20px; border-bottom: 1px solid #EEE;">班级成员</div>
                <div class="student-item" v-for="(stu, index) in stuList" @click="viewStudentDetail(stu)">
                    <!-- <img :src="stu.s_ico ? stu.s_ico : require('../../assets/images/user_img.png')" style="width: 40px; height: 40px; border-radius: 20px;">
                    <div style="color: #000; margin-left: 10px;">{{ stu.s_name }}</div> -->
                    <div class="avavtor">
                    <img :src="stu.s_ico ? stu.s_ico : require('../../assets/images/user_img.png')" /> 
                    <div class="circle" :class="stu.sex=='女'?'girl_circle':'boy_circle'">
                      <i class="iconfont" v-if="stu.sex=='女'">&#xe8b4;</i>
                      <i class="iconfont" v-else>&#xe8b3;</i>
                    </div> 
                  </div>
                  <div class="info">
                    <div class="top"><span class="name">{{ stu.s_name }}</span><span class="account">({{  stu.s_account}})</span></div>
                    <div class="bottom">{{ stu.create_time }}</div>
                  </div>
                  </div>
            </el-scrollbar>
        </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Myclass",
  data() {
    return {
      activeName: '课程内容',
      classId: Number(this.$route.query.classId) || "",
      className: "",
      stuList: [],
      operNum: {
        sx_num: "",
        xc_num: "",
        tl_num: "",
      },
      myCourses: [],
      signInData: [],
      course_record_id: "",

      courseSwiperOption: {
        autoplay: false,
        slidesPerView: 4,
        spaceBetween: 16,
        // loop: true,
        navigation: {
          nextEl: ".banner-swiper-btn-next",
          prevEl: ".banner-swiper-btn-prev",
        },
        observer: true,
        observeParents: true,
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  created() {
    this.getStudentList();
    this.getStatistics();
    this.getCourseList();
  },
  methods: {
    headStyle() {
        return 'background: #FAFAFA; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;'
    },
    cellStyle() {
        return 'padding-left: 24px; height: 60px; color: #333;'
    },
    targetCourse(row) {
      let route_query = {
        classId: this.classId,
        className: this.className,
        id: row.course_id,
        recordId: row.id,
        chapter: 0,
        node: 0,
      };
      let { href } = this.$router.resolve({ path: "/course/inClass", query: route_query });
      window.open(href, "_blank");
    },
    signIn() {
      this.dialogVisible = !this.dialogVisible;
    },
    getStudentList() {
      let params = {
        type: "all",
        c_id: this.classId,
      };
      this.$shttp.axiosGetBy(
        this.$api.showStudent,
        params,
        (res) => {
          if (res.code === 200) {
            if (res.data.length) {
              this.stuList = res.data;
              this.className = res.data[0].c_name;
            } else {
              this.className = res.data.c_name;
            }
          } else {
            this.$message.warning(res.msg);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getStatistics() {
      let params = {
        c_id: this.classId,
      };
      this.$shttp.axiosGetBy(
        this.$api.statistics,
        params,
        (res) => {
          if (res.code === 200) {
            this.operNum.sx_num = res.data.sx_num;
            this.operNum.xc_num = res.data.xc_num;
            this.operNum.tl_num = res.data.tl_num;
          } else {
            this.$message.warning(res.msg);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getCourseList() {
      let params = {
        c_id: this.classId,
      };
      this.$shttp.axiosGetBy(
        this.$api.getCourseProgressList,
        params,
        (res) => {
          if (res.code === 200) {
            this.myCourses = res.data.data1;
            this.signInData = res.data.data2.data;
          } else {
            this.$message.warning(res.msg);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    toPracticalList() {
      this.$router.push({ path: "/teacherClass/practicalList", query: { classId: this.classId, className: this.className } });
    },
    toQuizList() {
      this.$router.push({ path: "/teacherClass/quizList", query: { classId: this.classId, className: this.className } });
    },
    toDiscussList() {
      this.$router.push({ path: "/teacherClass/discussList", query: { classId: this.classId, className: this.className } });
    },
    goBack() {
      this.$router.go(-1);
    },
    //查看学生
    viewStudentDetail(item) {
      console.log("item", item);
      this.$router.push({
        path: "/teacherClass/student/detail",
        query: {
          sId: item.s_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  font-family: PingFang SC, PingFang SC;
}
.my-class {
  padding: 30px 16%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  .content-box {
    flex: 1;
    margin-right: 24px;
    background: #fff;
    padding: 20px 30px 30px 30px;
    ::v-deep .el-tabs__item.is-active {
      color: #006EFF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #006EFF;
    }
    ::v-deep .el-scrollbar__wrap {
      overflow: auto;
    }
  }
  .course-item {
    width: 100%;
    height: 156px;
    padding: 30px;
    margin-top: 30px;
    background: #F2F6FA;
    border: 1px solid #EEE;
    border-radius: 10px;
    display: flex;
  }
  .student-box {
    width: 210px;
    padding: 20px 0;
    background: #fff;
  }
  .student-item {
    height: 60px;
    border-bottom: 1px solid #eee;
    padding: 0 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .avavtor{
      width: 40px;
      height: 40px; 
      border-radius: 100%;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        border-radius: 100%;
        object-fit: cover;
      }
      .circle{
        position: absolute;
        width: 18px;
        height: 18px;
        bottom: 0px;
        right: 2px;
        // background: skyblue;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
      }
      .girl_circle{
        color: #FF6969 ;
        background: #ffd6d6;

      }
      .boy_circle{
        color: #006FFF ;
        background: #daeaff;
      }
    }
    .info{
      margin-left: 10px;
      .top{
          .name{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .account{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 3px;
        }
      }
      .bottom{
        margin-top: 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}
</style>
